export enum PostMessage {
  TAKE_CALL_NOTIFICATION = 'TAKE_CALL_NOTIFICATION',
}
